import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface AllTermSetState {
  data: [] | null | any;
  currentPage: number | null;
  totalRecords: number | null;
  totalPages: number | null;
}

const initialState: AllTermSetState = {
  data: null,
  totalRecords: null,
  totalPages: null,
  currentPage: null,
};

export const allTermSetSlice = createSlice({
  name: 'allTermSet',
  initialState,
  reducers: {
    setAllTermSet: (state, action) => {
      state.data = action.payload.data.content;
      state.totalRecords = action.payload.data.totalElements;
      state.totalPages = action.payload.data.totalPages;
      state.currentPage = action.payload.data.number;
    },
    setAllTermSetBySearch: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPages;
      state.currentPage = action.payload.data.currentPage;
    },
    reset: (state) => {
      state = initialState;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setAllTermSet,setAllTermSetBySearch,reset } = allTermSetSlice.actions;
export const getAllTermSetDetails = (state: RootState) => state.allTermSet.data;
export const getAllTermSetDetailsBySearch = (state: RootState) => state.allTermSet.data;
export const getTermSetTotalRecords=(state:RootState)=>state.allTermSet.totalRecords;
export default allTermSetSlice.reducer;